export const GRANULOMETRY_OUTDATED = 'granulometry/outdated';

export const granulometryOutdated = () => <const>{ type: GRANULOMETRY_OUTDATED };

export type GranulometryOutdatedAction = ReturnType<typeof granulometryOutdated>;
